import { useFocusedMeetingAPI, useMeetingSelector } from "../../../../hooks/meeting";

import { useStudentContext } from "../context";

import styles from "./dashboard.module.css";
import { RemotesToExpertsContainer } from "../../../../components/player/container/RemotesToExpertsContainer";
import { useMemo } from "react";

import "./dashboard.css"

export const MeetingHighlightStudentPage = () => {
  const studentCtx = useStudentContext();
  const meetingCtx = useFocusedMeetingAPI();
  const [session] = useMeetingSelector(meetingCtx, (state) => state.session);

  // ---------------------------------------------------------------------- //
  // ---------------------------   EFFECT ----------------------------- //
  // ---------------------------------------------------------------------- //

  const self = useMemo(() => {
    return undefined;
    // return {
    //   present: !!(
    //     studentCtx?.selfVideoStream 
    //     && session?.highlighting === MeetingSessionHighlightingState.ONGOING
    //   ),
    //   videoStream: session?.highlighting === MeetingSessionHighlightingState.ONGOING ? studentCtx?.selfVideoStream : undefined,
    //   screens: true,
    // };
  }, [studentCtx?.selfStreams, session]);

  
  // ---------------------------------------------------------------------- //
  // ---------------------------   RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  if (!studentCtx) return null;

  const { currentView, layout } = studentCtx;

  if (currentView?.type !== "highlight") return null;

  return (
    <div className={styles.container}>
      <RemotesToExpertsContainer
        remoteSessions={currentView.students.filter(data => data.video).map(data => data.session)}
        expertSessions={currentView.experts.filter(data => data.video).map(data => data.session)}
        self={self}
        layout={layout}
      />
    </div>
  );
};
